import script from "./noticeBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./noticeBar.vue?vue&type=script&setup=true&lang=ts"

import "./noticeBar.vue?vue&type=style&index=0&id=b79a2f96&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b79a2f96"]])

export default __exports__